import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: localStorage.getItem('token')||''
    },
    mutations: {
        setToken(state, data) {
            state.token = data
            localStorage.setItem('token', data)
        }
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js